import axios from "@/config/axios";
const initiateState = () => {
    return {
        menuManagementAddStatus: false,
        menuManagementUpdateStatus: false,
        menuManagementDeleteStatus: false,
        menuManagementDeleteError: false,
        allMenuData: [],
        menuManagementErrors: [],
        menu: {},
        deleteMenuStatus: false,
        menuList: [],
        entityMenu: null,
        allEntityMenus: null,
        originalEntityMenuList: null,
        currentMenu: null
    }
}
const state = initiateState()
const getters = {
    getMenuManagementAddStatus: state => state.menuManagementAddStatus,
    getMenuManagementUpdateStatus: state => state.menuManagementUpdateStatus,
    getMenuManagementErrors: state => state.menuManagementErrors,
    getMenu: state => state.menu,
    getDeleteMenuStatus: state => state.deleteMenuStatus,
    getMenuList: state => state.menuList,
    getEntityMenu: state => state.entityMenu,
    getAllEntityMenus: state => state.allEntityMenus,
    getCurrentMenu: state => state.currentMenu,
    getOriginalEntityMenuList: state => state.originalEntityMenuList,
}
const mutations = {
    setDeleteMenuStatus(state, data) {
        state.deleteMenuStatus = data
    },
    setMenuManagementAddStatus(state, data) {
        state.menuManagementAddStatus = data
    },
    setMenuManagementUpdateStatus(state, data) {
        state.menuManagementUpdateStatus = data
    },
    setMenu(state, data) {
        state.menu = data
    },
    setMenuManagementErrors(state, data) {
        state.menuManagementErrors = data
    },
    setMenuList(state, data){
        state.menuList = data
    },
    setEntityMenu(state, data) {
        state.entityMenu = data
    },
    setAllEntityMenus(state, data) {
        state.allEntityMenus = data
    },
    setOriginalEntityMenuList(state, data) {
        state.originalEntityMenuList = data
    },
    setCurrentMenu(state, data) {
        state.currentMenu = data
    },  
    resetData: state => {
        const initial = initiateState();
        Object.keys(initial).forEach(key => {
            state[key] = initial[key];
        });
    },
}
const actions = {
    reset: function (context) {
        context.commit("menuManagementV2/resetData", null, {
            root: true
        });
    },
    async clearErrors(context) {
        try {
            context.commit("menuManagementV2/setMenuManagementErrors", {}, {
                root: true
            })
        } catch (err) {
            console.log(err)
        }
    },
    async addMenuManagement(context, params) {
        try {
            context.commit("menuManagementV2/setMenuManagementAddStatus", false, {
                root: true
            })
            await axios.post('menu/v2', params)
            context.commit("menuManagementV2/setMenuManagementAddStatus", true, {
                root: true
            })
        } catch (error) {
            context.commit("menuManagementV2/setMenuManagementAddStatus", false, {
                root: true
            })
            if (error.response) {
                const errors = await context.dispatch("menuManagementV2/errorResponse", error.response, {
                    root: true
                });
                context.commit("menuManagementV2/setMenuManagementErrors", errors, {
                    root: true
                })
            }
        }
    },
    async updateMenuManagement(context, params) {
        try {
            context.commit("menuManagementV2/setMenuManagementUpdateStatus", false, {
                root: true
            })
            await axios.put('menu/v2', params)
            context.commit("menuManagementV2/setMenuManagementUpdateStatus", true, {
                root: true
            })
        } catch (error) {
            context.commit("menuManagementV2/setMenuManagementUpdateStatus", false, {
                root: true
            })
            if (error.response) {
                const errors = await context.dispatch("menuManagementV2/errorResponse", error.response, {
                    root: true
                });
                context.commit("menuManagementV2/setMenuManagementErrors", errors, {
                    root: true
                })
            }
        }
    },
    async fetchMenuWithUserType(context, id) {
        try {
            context.commit("menuManagementV2/setMenu", {}, {
                root: true
            })
            const response = await axios.get(`menu/v2/${id}`)
            context.commit("menuManagementV2/setMenu", response.data.data, {
                root: true
            })
        } catch (errors) {
            context.commit("menuManagementV2/setMenu", {}, {
                root: true
            })
        }
    },
    async fetchMenuByEntity(context, id) {
        try {
            context.commit("menuManagementV2/setEntityMenu", null, {
                root: true
            })
            const response = await axios.get(`menu/v2/entity/${id}`)
            context.commit("menuManagementV2/setEntityMenu", response.data.data, {
                root: true
            })
            return response.data.data
        } catch (errors) {
            context.commit("menuManagementV2/setEntityMenu", null, {
                root: true
            })
        }
    },
    async fetchAllMenusByEntity(context, id) {
        try {
            context.commit("menuManagementV2/setAllEntityMenus", null, {
                root: true
            })
            const response = await axios.get(`menus/v2/entity/${id}`)
            context.commit("menuManagementV2/setAllEntityMenus", response.data.data, {
                root: true
            })
        } catch (errors) {
            context.commit("menuManagementV2/setAllEntityMenus", null, {
                root: true
            })
        }
    },
    async fetchMenuWithUserTypes(context, params) {
        try {
            const response = await axios.post(`menu/v2/usertypes`, params)
            context.commit("menuManagementV2/setMenuList", response.data.data, {
                root: true
            })
             return response;
        } catch (errors) {
            context.commit("menuManagementV2/setMenuList", {}, {
                root: true
            })
            return null; 
        }
    },
    errorResponse: (context, errorResponse) => {
        let errorStatusCode = errorResponse.status;
        let errorData = {};
        switch (errorStatusCode) {
            case 422:
                var errors = errorResponse.data.errors;
                errors.details.forEach(detail => {

                    if (detail.key == "files") {
                        if (!errorData[detail.path]) {
                            errorData[detail.path] = detail.message
                        }
                    } else {
                        if (!errorData[detail.key]) {
                            errorData[detail.key] = detail.message;
                        }
                    }
                });
                break;
            case 401:
            case 403:
                errorData["critical_error"] = errorResponse.data.message;

                break;

            default:
                errorData["critical_error"] = errorResponse.data.message;
                break;
        }
        return errorData;
    },
    async deleteMenuById(context, id) {
        try{
            context.commit("menuManagementV2/setDeleteMenuStatus", false, {
                root: true
            });
            await axios.delete(`menu/v2/${id}`);
            context.commit("menuManagementV2/setDeleteMenuStatus", true, {
                root: true
            });
        } catch (error){
            if (error.response) {
                const errors = await context.dispatch("menuManagementV2/errorResponse", error.response, {
                    root: true
                });
                context.commit("menuManagementV2/setMenuManagementErrors", errors, {
                    root: true
                })
            }
        }
    },
}
export default {
    namespaced: true,
    mutations,
    getters,
    state,
    actions
}